module.exports = __webpack_public_path__ + "img/bronze.fd7029c6.svg";